<template>
  <div>
    <HomeBannerTop></HomeBannerTop>
    <div class="actor-list-box">
      <template v-if="dataList.length > 0">
        <div class="collection-title">{{ $t('我的收藏') }}</div>
        <div v-for="(item, index) in dataList" :key="index">
          <actorCard showType="collection" :index="index" :vData="item" @collect="collectEvent_a" />
        </div>
      </template>
      <template v-else>
        <hNoData></hNoData>
      </template>

    </div>
    <div class="tc mt20">
      <el-pagination v-if="dataList.length > 0" background @current-change="handleCurrentChange"
        :page-size="query.pageRows" :current-page.sync="query.pageNum" layout="total, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>
    <!-- 底部信息 -->
    <HomeFooter></HomeFooter>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
// 顶部内容
import HomeBannerTop from '../index/HomeBannerTop'
// 底部内容
import HomeFooter from '../index/HomeFooter'

import { eventMixin } from '@/mixins/event.js'
import actorCard from './components/actorCard'
import hNoData from '@/components/hNoData'
import { getCollectionPersonList, getCollectionProductList, getCollectionActorList } from '@/api/collection'
export default {
  mixins: [eventMixin],
  components: {
    HomeBannerTop,
    HomeFooter,
    actorCard,
    hNoData
  },
  data() {
    return {
      loading: false, // 页面loading
      loading2: false, // 筛选loading
      dataList: [], // 数据
      query: { // 搜索值
        pageNum: 1,
        pageRows: 10,
        total: 0,
      },
    }
  },
  computed: {
    ...mapGetters(['exhibitorId', 'language', 'info', 'subjectType']),
  },
  mounted() {
    sessionStorage.removeItem('actorID')
    this.pageInit()
  },
  methods: {
    // 更新收藏状态
    updateCollect(status, index) {
      this.dataList[index]['collected'] = status
    },
    // 找展商 收藏
    collectEvent_a(params, index, data) {
      params.collectionSubjectId = data.id
      params.id = data.collectionId
      this.collectEvent(params, index)
    },
    // 返回首页
    goHome() {
      this.$router.push(`/`)
    },
    // 页码 change
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.fetchDataList()
      this.$funcs.scrollToY(0, 10)
    },
    // 初始化
    pageInit() {
      this.fetchDataList()
    },
    // 获取列表
    fetchDataList() {
      this.loading = true
      this.fetchActorList()
    },
    // 获取展商列表
    fetchActorList() {
      getCollectionActorList({
        ...this.query,
        showType: 'ACTOR'
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            let data = res.data
            this.query.total = data.total || 0
            this.query.pages = data.pages || 0
            this.dataList = data.list || []
          }
        })
        .finally(() => {
          this.loading = false
          this.loading2 = false
        })
    },
  }
  }
</script>

<style lang="scss" scoped>
.collection-title{
  margin-bottom: 20px;
  font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 18px;
    background: -webkit-linear-gradient(top, #00875E, #0068A9);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}
.actor-list-box {
  max-width: 1080px;
  margin: auto;
  background: #fff;
  margin-top: 16px;
  padding: 24px;
}
</style>